import Bubble from ".";

export const bubbleRoutes = () => [
  {
    path: "/admin/bubble",
    title: "Bubble Management",
    layout: "admin",
    routeType: "admin",
    component: Bubble,
  },
]